import React from 'react'
import { StyledRegistrationButton, StyledRegistrationButtonProps } from './styled'

const Index: React.FC<StyledRegistrationButtonProps> = ({ className, size }) => {
  return (
    <StyledRegistrationButton size={size} className={className} />
  )
}

export default Index
